import { useQueryClient } from '@tanstack/react-query'
import { LectureQuestionDeleteRequest } from '../../../types/video'
import { useApiPostMutation } from '../useApi'

export const useQuestionsDeleteSpecific = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<LectureQuestionDeleteRequest>()

  const deleteQuestion = async (requestData: LectureQuestionDeleteRequest) => {
    const result = await mutation.mutateAsync({
      url: '/lectures/questions/delete',
      data: requestData,
    })

    queryClient.invalidateQueries({ queryKey: ['questionsDetail'] })
    queryClient.invalidateQueries({ queryKey: ['lecture-list'] })

    return result
  }

  return {
    ...mutation,
    deleteQuestion,
  }
}
